/** Returns a low-quality preview URL when the CDN supports width transforms; otherwise same src. */
export function getLowQualityPreviewUrl(src: string): string {
  try {
    const url = new URL(src, window.location.origin);
    if (url.hostname.endsWith('utfs.io') || url.hostname.endsWith('ufs.sh')) {
      url.searchParams.set('w', '32');
      return url.toString();
    }
  } catch {
    // relative or invalid URL — use as-is
  }
  return src;
}
